import React, { Suspense } from "react";
import { Redirect, Route } from "react-router-dom";
import { useAuth } from "../../auth/use-auth";
// import jwt_decode from "jwt-decode";

function LayoutRoute({
    component: Component,
    authRequired,
    layout: Layout,
    ...rest
}) {
    let auth = useAuth();
    // if (auth.user) {
    //     let decodedToken = jwt_decode(auth.user.access_token);
    //     let currentDate = new Date();
    //     // JWT exp is in seconds
    //     if (decodedToken.exp * 1000 < currentDate.getTime()) {
    //         auth.signout();
    //     }
    // }
    let toLogout = localStorage.getItem("logout");    
    if(toLogout) {
      auth.signout();
    }

    return (
        <Route
            {...rest}
            render={({ props, location }) => {
                if (!authRequired || auth.user) {
                    return (
                        <Layout>
                            <Suspense fallback={<div>Loading...</div>}>
                                <Component {...props} />
                            </Suspense>
                        </Layout>
                    );
                } else {
                    return (
                        <Redirect
                            to={{
                                pathname: "/login",
                                state: { from: location },
                            }}
                        />
                    );
                }
            }}
        />
    );
}

export default LayoutRoute;
